import { createContext, useContext } from "react";

import { CurrentUser } from "@rossum/upcloud-costs-shared";

export const CurrentUserContext = createContext<CurrentUser | null>(null);

/** The authenticated user; only available below `RequireUser`. */
export function useCurrentUser(): CurrentUser {
    const user = useContext(CurrentUserContext);
    if (user === null) {
        throw new Error("useCurrentUser must be used within RequireUser");
    }
    return user;
}
